import { useEffect, useState } from 'react';
import LicenseData from '../components/LicenseData';
import API_ROOT from '../config';
import { useFetch } from './Launchpad';
import { PrimaryButton, SecondaryButton } from '../components/Button';
import Accordion from '../components/Accordion';

function AllKeys({ tenant, onDone }) {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [more, setMore] = useState(false);
  const [history, setHistory] = useState(true);
  const [results, setResults] = useState([]);
  const { fetchWithAuth } = useFetch();
  const [activeOnly, setActiveOnly] = useState(true);



  const nextPage = () => {
    setPage(page + 1);
  }

  const prevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  }

  useEffect(() => {

    const lookup = async (thisPage) => {

      setMore(false);
      setMessage('');

      const response = await fetchWithAuth(`${API_ROOT}/v1/license/${tenant}?history=${history}&page=${thisPage}&count=${pageSize}&activeOnly=${activeOnly}`);
      if (response.status === 404) {
        setMessage('License not found.');
        setResults([]);
        return;
      }
      if (response.status === 204) {
        setMessage('No licenses found.');
        setResults([]);
        return;
      }
      if (response.status === 206) {
        setMore(true);
      }
      if (!response.ok) {
        let errorText = await response.text();
        const errorPrefix = 'Unable to get licenses: ';
        try {
          let errorData = JSON.parse(errorText);
          setError(errorPrefix + (errorData.Message ?? ""));
        }
        catch (e) {
          setError(errorPrefix + errorText);
        }
        console.error(errorPrefix, response);
        return;
      }
      const resultsData = await response.json();
      setResults(resultsData);
    }
    lookup(page);
    // Refetch when page or tenant changes
  }, [page, tenant, history, pageSize, activeOnly]);

  return (
    <div>
      <div>{message}</div>
      <div>{error}</div>

      <input type="checkbox" checked={activeOnly} onChange={(e) => setActiveOnly(e.target.checked)} /> Show only active licenses

      <Accordion>
        {results.map((result, index) => (
          { header: `${result.egm}`, body: <LicenseData data={result} /> }
        ))}
      </Accordion>

      <div>

        {(page > 1) &&
          <PrimaryButton onClick={prevPage}>Previous</PrimaryButton>
        }

        {((page > 1) || more) && <span>Page {page}</span>}

        {(more) &&
          <PrimaryButton onClick={nextPage}>Next</PrimaryButton>
        }
      </div>
      <SecondaryButton onClick={onDone}>Done</SecondaryButton>
    </div>
  );
}

export default AllKeys;